module.exports = __webpack_public_path__ + "img/translate.81446be2.svg";